import domPurify from 'dompurify';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { theme } from '../theme';
export const RichText = forwardRef(function RichText({ htmlString, ...props }, ref) {
    const sanitisedHtml = domPurify.sanitize(htmlString);
    if (!domPurify.isSupported) {
        return (React.createElement(Box, { ...props },
            React.createElement(WarningText, null,
                React.createElement(Icon, { render: "warning" }),
                "Your browser is not supported, please upgrade to a newer version"),
            htmlString));
    }
    else {
        return (React.createElement(HtmlBox, { ref: ref, ...props, dangerouslySetInnerHTML: { __html: sanitisedHtml } }));
    }
});
const WarningText = styled(Box) `
  background-color: ${theme.colors.sherbert};
  padding: 16px;
  border-radius: 16px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;
const HtmlBox = styled(Box) `
  * {
    all: revert;
  }
`;
//# sourceMappingURL=RichText.js.map